<template>
  <div>
    <div>
      <div class="search-wrap">
        <el-button size="mini" @click="search">查询</el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" v-if="multipleSelection.length&&multipleSelection_meter_not_examine.length&&multipleSelection_meter_examine_type_num===1&&(ERP.isPermission(4007003007)||ERP.isPermission(8006002007)||ERP.isPermission(21004002007))" @click="dels()">删除</el-button>

<!--        <el-button size="mini" @click="ERP.navigateTo('/meter/meterNoteExcel?type='+($route.query.type||0))" style="margin-right: 5px;" v-if="ERP.isPermission(4007003002)||ERP.isPermission(8006002002)||ERP.isPermission(21004002002)">抄表</el-button>-->
<!--        <el-button size="mini" @click="ERP.navigateTo('/meter/meterNoteWrite?type='+($route.query.type||0))" style="margin-right: 5px;" v-if="ERP.isPermission(4007003003)||ERP.isPermission(8006002003)||ERP.isPermission(21004002003)">录入</el-button>-->

        <el-button size="mini" v-if="multipleSelection.length&&multipleSelection_meter_not_examine.length&&(ERP.isPermission(4007003008)||ERP.isPermission(8006002008)||ERP.isPermission(21004002008))" @click="examine(1)" style="margin-right: 5px;">审核</el-button>
        <el-button size="mini" v-if="multipleSelection.length&&multipleSelection_meter_examine.length&&(ERP.isPermission(4007003009)||ERP.isPermission(8006002009)||ERP.isPermission(21004002009))" @click="examine(0)" style="margin-right: 5px;">反审核</el-button>
        <el-button size="mini" style="margin-right: 5px;" @click="allExamine(1)" v-if="ERP.isPermission(4007003004)||ERP.isPermission(8006002004)||ERP.isPermission(21004002004)">全部审核</el-button>
        <el-button size="mini" style="margin-right: 5px;" @click="allExamine(0)" v-if="ERP.isPermission(4007003005)||ERP.isPermission(8006002005)||ERP.isPermission(21004002005)">全部反审核</el-button>

<!--        <el-button size="mini" style="margin-right: 5px;" @click="flow()" v-if="ERP.isPermission(4007003010)||ERP.isPermission(8006002010)||ERP.isPermission(21004002010)">流程审核</el-button>-->
<!--        <el-button size="mini" style="margin-right: 5px;" @click="allFlow()" v-if="ERP.isPermission(4007003011)||ERP.isPermission(8006002011)||ERP.isPermission(21004002011)">全部流程审核</el-button>-->

        <el-button size="mini" style="margin-right: 5px;" @click="notFreeze()" v-if="ERP.isPermission(4007003010)||ERP.isPermission(8006002010)||ERP.isPermission(21004002010)">解锁</el-button>
        <el-button size="mini" style="margin-right: 5px;" @click="allNotFreeze()" v-if="ERP.isPermission(4007003011)||ERP.isPermission(8006002011)||ERP.isPermission(21004002011)">全部解锁</el-button>

        <el-button type="danger" size="mini" icon="el-icon-delete" @click="allDel()" v-if="ERP.isPermission(4007003001)||ERP.isPermission(8006002001)||ERP.isPermission(21004002001)">全部删除</el-button>

<!--        <el-button size="mini" icon="el-icon-info" @click="openViewFile(host_url+'/word_template/yi_biao_guan_li_chao_zuo_zhi_yin.docx','仪表管理操作指引')">仪表操作指引</el-button>-->
      </div>

      <div style="margin-bottom: 10px;">
        <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
          <el-descriptions-item label="仪表编号">
            <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="当前房产">
            <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
<!--          <el-descriptions-item label="线路">-->
<!--            <el-input size="mini" placeholder="请输入线路" v-model="where.line" clearable></el-input>-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="仪表状态">
            <el-checkbox-group v-model="where.status_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="仪表名称">
            <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan" @change="pageChange(1)">
              <el-option
                v-for="item in meter_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="仪表性质">
            <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="审核标志">
            <el-checkbox-group v-model="where.is_examine_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in [{name:'未审核',val:0},{name:'已审核',val:1}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="能耗类型">
            <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
              <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="锁定状态">
            <el-checkbox-group v-model="where.is_freezes" @change="pageChange(1)">
              <el-checkbox v-for="item in [{name:'未锁',val:0},{name:'已锁',val:1}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
            <span style="color: #757575;font-size: 14px;">锁定是指在发起流程中的仪表进入了锁定状态</span>
          </el-descriptions-item>
          <el-descriptions-item label="抄表日期">
            <div v-if="where.read_type===2">
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    style="width: 100%"
                    size="mini"
                    v-model="where.start_time"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" @change="pageChange(1)">
                  </el-date-picker>
                </el-col>
                <el-col :span="2">
                  至
                </el-col>
                <el-col :span="11">
                  <el-date-picker
                    style="width: 100%"
                    size="mini"
                    v-model="where.end_time"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" @change="pageChange(1)">
                  </el-date-picker>
                </el-col>
              </el-row>
            </div>
            <div v-if="where.read_type===1">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.read_month"
                :clearable="false"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM" @change="pageChange(1)">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;">
              <el-radio v-model="where.read_type" :label="1">按月</el-radio>
              <el-radio v-model="where.read_type" :label="2">自定义</el-radio>

              <el-radio v-model="where.time_type" :label="1">抄表日期</el-radio>
              <el-radio v-model="where.time_type" :label="2">登记日期</el-radio>
            </div>
          </el-descriptions-item>
<!--          <el-descriptions-item label="用量异常">-->
<!--            <el-radio disabled size="mini" v-for="item in [{name:'是',val:1},{name:'否',val:0}]"-->
<!--                      :key="item.val" v-model="where.is_accident" :label="item.val">{{ item.name }}</el-radio>-->
<!--          </el-descriptions-item>-->
        </el-descriptions>
      </div>

      <div class="header-tip">
        抄表数：{{count_obj.read}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        锁定数：{{count_obj.freeze}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        已审数：{{count_obj.examine}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>

      <div>
        <el-table v-if="pageData" v-loading="loading" border width="99%" height="calc(100vh - 550px)" :data="pageData.list" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" fixed></el-table-column>
          <el-table-column prop="id" label="id" width="80" fixed></el-table-column>
          <el-table-column prop="house_name" label="所在房产" width="200" fixed></el-table-column>
          <el-table-column prop="number" label="仪表编号 " width="140" fixed>
            <template slot-scope="scope">
              <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="仪表名称 " width="100"></el-table-column>
<!--          <el-table-column prop="line" label="线路 " width="100"></el-table-column>-->
          <el-table-column prop="meter_type_name" label="仪表类型" width="100"></el-table-column>
          <el-table-column prop="charging_standard_name" label="收费标准 " width="200"></el-table-column>
          <el-table-column prop="current_price" label="单价 " width="80"></el-table-column>
          <el-table-column prop="read_number" label="本期读数" width="80">
          </el-table-column>
          <el-table-column prop="dosage_number" label="本期用量" width="80"></el-table-column>
          <el-table-column prop="read_time" label="抄表日期" width="100"></el-table-column>
          <el-table-column prop="mn_remarks" label="备注" width="100"></el-table-column>
          <el-table-column prop="last_year_dosage_number" label="去年同期用量" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.last_year_dosage_number}}</span>
              <span style="color: #ff1818;" v-if="scope.row.tong_bi>(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↑</span>
              <span style="color: #3b6ed9;" v-if="scope.row.tong_bi<-(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↓</span>
            </template>
          </el-table-column>
          <el-table-column prop="last_dosage_number" label="上期用量" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.last_dosage_number}}</span>
              <span style="color: #ff1818;" v-if="scope.row.huan_bi>(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↑</span>
              <span style="color: #3b6ed9;" v-if="scope.row.huan_bi<-(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↓</span>
            </template>
          </el-table-column>
          <el-table-column prop="mn_admin_name" label="抄表人" width="80"></el-table-column>
          <el-table-column prop="is_examine" label="审核" width="80">
            <template slot-scope="scope">
              {{scope.row.is_examine?'已审':'未审'}}
            </template>
          </el-table-column>
          <el-table-column prop="mn_task_id" label="流程ID" width="80">
            <template slot-scope="scope">
              <el-link type="primary">{{scope.row.mn_task_id}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="mn_files" label="图片" width="100">
            <template slot-scope="scope">
              <el-popover v-if="scope.row.mn_files.length>0"
                          placement="right"
                          width="500"
                          trigger="hover">
                <div>
                  <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="(item,index) in scope.row.mn_files" :key="index">
                      <el-image fit="cover" style="width: 480px; " :src="item"></el-image>
                    </el-carousel-item>
                  </el-carousel>

                </div>
                <el-image slot="reference" v-for="(item,index) in scope.row.mn_files" :key="index"
                          style="width: 80px; height: 80px"
                          :src="scope.row.mn_files[0]"
                          fit="cover"></el-image>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作 " width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showAnalysis(scope.row)" >能耗分析</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px;text-align: center;margin-right: 20px;display: flex;flex-direction: row;align-items: center;justify-content: center;">
        <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
        <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
      </div>
    </div>
    <!-- 修改窗口 -->
    <MeterInfo ref="MeterInfo" />

    <el-dialog class="dialog-cache" z-index="990" :visible.sync="dialogCacheVisible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" width="90vw" top="5vh">
      <div slot="title" class="dialog-footer">
        <el-button size="mini" @click="closeGoFlow">关 闭</el-button>
        <el-button size="mini" @click="isGoFlow">发起流程</el-button>
      </div>
      <div>
        <p>注意：</p>
        <ol>
          <li>读数列表：确认发起流程的仪表读数，尽量<span style="color: rgb(255, 77, 79);">避开公摊的和业主的同时发起流程</span>的情况。</li>
          <li>抄表费用：如果没费用时请点击【<span style="color: rgb(255, 77, 79);">生成账单</span>】，按照生成账单的提示流程操作。</li>
          <li>抄表调整：抄表调整是发现表多了或者读数不对的时候提供的流程中修改的渠道。</li>
        </ol>
      </div>
      <MeterNoteViewCache v-if="dialogCacheVisible" :batch_number2="batch_number" :master_id2="master_id" :task_id2="task_id"  />
    </el-dialog>

    <MeterNoteAnalysisWindow ref="MeterNoteAnalysisWindow" />

    <ViewFile ref="ViewFile" />

  </div>
</template>

<script>
import MeterNoteViewCache from "../../../Meter/MeterNoteViewCache";
import ErpTreeStatus from "../../../Common/erp-tree-status";
import UploadFilesSysc from "../../../Contract/components/UploadFilesSysc";
import ErpTree from "../../../Common/erp-tree";
import moment from "moment";
import MeterInfo from "../meter/components/MeterInfo";
import MeterNoteAnalysisWindow from "./components/MeterNoteAnalysisWindow";
import ViewFile from "../../../Common/ViewFile";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterNoteList",
  components: {ViewFile, MeterNoteAnalysisWindow, MeterInfo, MeterNoteViewCache, ErpTreeStatus, UploadFilesSysc, ErpTree},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_type:"",
        is_accident:"",
        is_examine:"",
        is_examine_ids:[1,0],
        start_time:moment(new Date()).startOf('month').format("YYYY-MM-DD"),
        end_time:moment(new Date()).endOf('month').format("YYYY-MM-DD"),
        read_month:moment(new Date()).endOf('month').format("YYYY-MM"),
        read_type:1,
        time_type:1,
        energy_ids:this.getDefaultEnergyIds(),
        is_freezes:[0,1],
        meter_virtually:[1]
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      treeDialogVisible: false,
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      charging_standard:"",
      mapDialogTableVisible:false,
      updateDialogVisible:false,
      yDialogVisible:false,
      mapCenter:[0,0],

      batch_number:'',
      task_id:0,
      master_id:0,

      dialogCacheVisible:false,
      count_obj:{},
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getMeterTypeList()

    this.where.house_name=that.mainObj.house_name;
    this.where.house_name&&this.getList();

  },
  watch: {
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.where.house_name=n;
      this.getList();
    }
  },
  computed: {
    multipleSelection_meter_ids(){
      return this.multipleSelection.map(ret=>{
        return ret.mn_id
      });
    },
    multipleSelection_meter_examine_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.is_examine)
      });
      return Array.from(set).length;
    },
    multipleSelection_meter_examine(){
      return this.multipleSelection.filter(ret=>{
        return !!ret.is_examine
      });
    },
    multipleSelection_meter_not_examine(){
      return this.multipleSelection.filter(ret=>{
        return !ret.is_examine
      });
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where);
      MeterHttp.post("MeterNote/getList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list=res.data.list.map(ret => {
            ret.mn_files=that.readImages(ret.mn_files)
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
        that.getCount();
      })
    },
    getCount() {
      const that = this;
      let where = reObject(this.where);
      MeterHttp.get("MeterNote/getCount",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0)
      }, res => {
        if (res.code) {
          that.count_obj = res.data
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      this.$refs.MeterInfo.show(item);
    },

    setFrom(data){
      const that = this;
      MeterHttp.post("MeterNote/save?user_type="+(that.$route.query.type||0), data, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    del(item) {
      const that = this;
      MeterHttp.post("MeterNote/delete?user_type="+(that.$route.query.type||0), {
        project_id:that.mainObj.project_id,
        id: item.id
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    dels() {
      const that = this;
      MeterHttp.post("MeterNote/delete?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        ids: this.multipleSelection_meter_ids.join(',')
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    allDel() {
      const that = this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      MeterHttp.post("MeterNote/allDel",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(that.where),
        user_type:(that.$route.query.type||0),
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    examine(is_examine=0){
      var that=this;
      that.setFrom({
        ids:this.multipleSelection_meter_ids.join(','),
        is_examine:is_examine,
      })
    },
    allExamine(is_examine=0){
      var that=this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      MeterHttp.post("MeterNote/allUpdate",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(that.where),
        user_type:(that.$route.query.type||0),
        data:JSON.stringify({is_examine:is_examine,is_cost_account:0})
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    shoeTreeDialogVisible() {
      this.treeDialogVisible = true;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      MeterHttp.get("HouseCharge/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    showMapDialogTableVisible(){
      this.mapDialogTableVisible=true
    },
    AmapManager(e){
      console.log(e)
    },
    amapManagerClick(e){
      console.log(e)
    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel?type="+(this.$route.query.type||0));
    },
    stopUse(){
      const that = this;
      that.$confirm('您确定停用该仪表吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          status:0
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    updateChargingStandard(){
      var that=this;
      that.$confirm('您确定修改该仪表收费标准吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          charging_standard:that.charging_standard,
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });

    },
    isGoFlow(){
      const that = this;
      let timeValue=(new Date()).getTime()
      MeterHttp.post("MeterFlow/listenin?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        batch_number:that.batch_number,
      }, res => {
        if(res.code===200){
          if(that.master_id===41){
            ERP.navigateTo(`/flow/FlowView?sheet_id=43&master_id=${that.master_id}&batch_number=${that.batch_number}&timeValue=${timeValue}`)
          }else {
            ERP.navigateTo(`/flow/FlowView?sheet_id=45&master_id=${that.master_id}&batch_number=${that.batch_number}&timeValue=${timeValue}`)
          }
          that.dialogCacheVisible=false;
          that.batch_number=""
        }else {
          that.$message.error(res.message||'数据异常');
        }
      })
    },
    closeGoFlow(){
      const that = this;
      that.$confirm('您确定要放弃发起吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterNote/closeMeterNoteFlow?user_type="+(that.$route.query.type||0),{
          project_id:that.mainObj.project_id,
          batch_number:that.batch_number,
        }, res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if (res.code) {
            that.batch_number="";
            that.dialogCacheVisible=false;
            that.getList()
          }
        })
      })
    },
    btnFlow(){
      const that = this;
      if(that.$route.query.type>0){
        that.$route.query.type==1&&(that.master_id=43);
        that.$route.query.type==2&&(that.master_id=41);
        that.dialogCacheVisible=true;
      }else {
        that.$confirm('选择工程抄表/管家抄表', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '工程抄表',
          cancelButtonText: '管家抄表',
          type: 'warning',
          center: true
        }).then(() => {
          // ERP.navigateTo("/flow/FlowView?sheet_id=43&master_id=41&batch_number="+res.data)
          that.master_id=41;
          that.dialogCacheVisible=true;
        }).catch(() => {
          // ERP.navigateTo("/flow/FlowView?sheet_id=45&master_id=43&batch_number="+res.data)
          that.master_id=43;
          that.dialogCacheVisible=true;
        });
      }
    },
    flow(){
      const that = this;
      that.$confirm('您确定要发起抄表审批吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterNote/meterNoteFlow?user_type="+(that.$route.query.type||0),{
          project_id:that.mainObj.project_id,
          ids:that.multipleSelection_meter_ids.join(','),
        }, res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if (res.code) {

            that.batch_number=res.data;
           that.btnFlow()
          }
        })
      })
    },
    allFlow(){
      const that = this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      that.$confirm('您确定要发起抄表审批吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterNote/allMeterNoteFlow",{
          project_id:that.mainObj.project_id,
          where: JSON.stringify(that.where),
          user_type:(that.$route.query.type||0),
        }, res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if (res.code) {
            that.batch_number=res.data;
            that.btnFlow()
          }
        })
      })
    },
    notFreeze(){
      const that = this;
      that.$confirm('当前操作会解锁正在发起流程的读数，但不会解锁已经发起成功的或已审核的读数，您确定要解锁吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterNote/meterNoteFlow?user_type="+(that.$route.query.type||0),{
          project_id:that.mainObj.project_id,
          ids:that.multipleSelection_meter_ids.join(','),
          type:1,
        }, res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if (res.code) {
            that.getList()
          }
        })
      })
    },
    allNotFreeze(){
      const that = this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      that.$confirm('当前操作会解锁正在发起流程的读数，但不会解锁已经发起成功的或已审核的读数，您确定要解锁吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterNote/allMeterNoteFlow?user_type="+(that.$route.query.type||0),{
          project_id:that.mainObj.project_id,
          where: JSON.stringify(that.where),
          user_type:(that.$route.query.type||0),
          type:1,
        }, res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if(res.code) {
            that.getList()
          }
        })
      })
    },
    readImages(mn_files){
      if(mn_files){
        let images=mn_files.split(',');
        return images.map(url=>{
          return loadUrl(url);
        })
      }else {
        return [];
      }
    },
    showAnalysis(item){
      this.$refs.MeterNoteAnalysisWindow.show(item.id,item.number+"_"+item.name)
    },
    openViewFile(src,title){
      const that=this;
      that.$refs.ViewFile.show({
        width: '90vw',
        height:'80vh',
        title:title,
        src:src,
        download(){
          // TODO 下载文件逻辑
          window.open(src)
        }
      })
    }
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
function loadUrl(url){
  return "https://meter.gdzawy.com:9000"+url;
}
</script>

<style lang="scss" scoped>
@import "../../common";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
.dialog-cache{
  >>>.el-dialog__body{
    padding-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterNoteList.vue